import React, { useRef } from "react";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import advanced from "dayjs/plugin/advancedFormat";
import { copyToClipboard, getZscalerURLParams } from "../utilities/utilities";
import { useSetRecoilState } from "recoil";
import showClipboardAtom from "../recoil/clipboard/showClipboardAtom";

// Extend dayjs to add support for timezone and timezone formatting.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advanced);

const Details = () => {
  const serviceNowInfoRef = useRef();
  const params = getZscalerURLParams();
  const showClipboard = useSetRecoilState(showClipboardAtom);
  return (
    <div className="details-section">
      <div className="details">
        <div id="service-now-info" ref={serviceNowInfoRef}>
          <div>Proxy or Firewall: &nbsp;ZScaler</div>
          {params.user && <div>Your User Name: &nbsp;{params.user}</div>}
          {params.category && (
            <div>Matching Categories: &nbsp;{params.category}</div>
          )}
          <div>
            Current Date &amp; Time: &nbsp;
            {dayjs().tz().format("ddd, MMM D, YYYY hh:mm A z")}
          </div>
          {params.url && <div>Full URL: &nbsp;{params.url}</div>}
        </div>
        <button
          onClick={() => {
            copyToClipboard(serviceNowInfoRef.current);
            showClipboard(true);
          }}
          style={{ marginTop: ".8em" }}
        >
          Copy Details to Clipboard
        </button>
      </div>
    </div>
  );
};

export default Details;
